var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubblesInformationGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.7699 34.3499V82.5899C92.7699 83.4194 92.6063 84.2407 92.2886 85.0069C91.9709 85.7731 91.5052 86.4692 90.9182 87.0553C90.3312 87.6413 89.6344 88.1059 88.8677 88.4224C88.101 88.739 87.2794 88.9012 86.4499 88.8999H27.9399L7.99988 108.81V34.3499C7.99457 33.5145 8.15519 32.6864 8.47243 31.9136C8.78966 31.1408 9.2572 30.4386 9.84791 29.8479C10.4386 29.2572 11.1408 28.7897 11.9136 28.4724C12.6864 28.1552 13.5145 27.9946 14.3499 27.9999H86.4499C87.2824 27.9999 88.1067 28.1643 88.8754 28.4838C89.6441 28.8033 90.3422 29.2715 90.9294 29.8616C91.5167 30.4516 91.9816 31.1519 92.2974 31.9221C92.6133 32.6924 92.7738 33.5174 92.7699 34.3499Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.32 73.6599V77.2699H41.48V73.6599H44.19C44.4824 73.6612 44.7721 73.6047 45.0426 73.4938C45.3131 73.3828 45.559 73.2195 45.7662 73.0132C45.9734 72.8069 46.1379 72.5617 46.25 72.2917C46.3622 72.0217 46.42 71.7322 46.42 71.4399V59.4399C46.42 58.8484 46.185 58.2812 45.7668 57.863C45.3486 57.4448 44.7814 57.2099 44.19 57.2099H41.48V53.6099H55.2V71.4399C55.2 71.7322 55.2577 72.0217 55.3699 72.2917C55.4821 72.5617 55.6465 72.8069 55.8537 73.0132C56.0609 73.2195 56.3069 73.3828 56.5774 73.4938C56.8478 73.6047 57.1376 73.6612 57.43 73.6599H59.32Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4299 43.32C55.4299 44.2836 55.1441 45.2255 54.6085 46.0266C54.0729 46.8277 53.3118 47.4519 52.4213 47.8202C51.5308 48.1885 50.5511 48.2844 49.6062 48.0956C48.6612 47.9069 47.7935 47.4421 47.1128 46.76C46.4321 46.0779 45.9691 45.2093 45.7823 44.2639C45.5955 43.3186 45.6934 42.3391 46.0635 41.4494C46.4337 40.5597 47.0594 39.7998 47.8616 39.2658C48.6638 38.7319 49.6063 38.448 50.5699 38.45C51.8598 38.4526 53.096 38.9669 54.0071 39.8799C54.9182 40.7929 55.4299 42.0301 55.4299 43.32Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5798 41.6799H135.1C135.927 41.6799 136.747 41.8437 137.511 42.1619C138.275 42.4802 138.968 42.9465 139.551 43.534C140.134 44.1215 140.595 44.8187 140.907 45.5851C141.219 46.3516 141.376 47.1723 141.37 47.9999V122",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.37 121.9L121.6 102.13H63.52C62.6966 102.131 61.881 101.97 61.1198 101.656C60.3586 101.343 59.6666 100.882 59.0835 100.301C58.5003 99.7193 58.0374 99.0288 57.7211 98.2686C57.4048 97.5084 57.2413 96.6933 57.24 95.8699V88.4399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6199 68.6599H121.56",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6199 76.8899H121.56",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6199 60.0498H121.56",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6199 85.1199H109.64",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubblesInformationGrey);
export default __webpack_public_path__ + "static/media/speech_bubbles_information_grey.cf110cf0bb831df9f5b89a56df4ab7b7.svg";
export { ForwardRef as ReactComponent };